export default function () {
  let errors = []

  if( typeof this.requiredInput !== 'undefined' && Array.isArray(this.requiredInput) ) {
    this.requiredInput.forEach(item => {
      if( this.input[item.key] === null || this.input[item.key] === '' )
        errors.push(item.title + ' is required')
    })
  }

  if( typeof this.extraValidation === 'function' ) {
    let result = this.extraValidation()
    if(result.length > 0)
      errors = errors.concat(result)
  }

  if( errors.length > 0 )
    this.alertNotice({
      type: 'danger',
      title: 'Failed',
      content: errors,
    })
  else
    return true
}